<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>KPI考核</el-breadcrumb-item>
            <el-breadcrumb-item>大盘绩效模板管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="10">
          <el-row :gutter="2">
            <el-col :span="5">
                <el-button type="danger" size="small" clearable @click="AddBigKPITemplateRelation(0)" plain>生成月度大盘绩效</el-button>
            </el-col>
            <el-col :span="5">
                <el-button type="danger" size="small" clearable @click="AddBigKPITemplateRelation(1)" plain>生成季度大盘绩效</el-button>
            </el-col>
            <el-col :span="3">
                <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col style="text-align:right;" :span="14">
              <el-button type="primary" size="small" @click="AddTask" plain>添加</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="BigTemplateList" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="KPIType" :formatter="KPITypeFormat" label="业绩指标"></el-table-column>
            <el-table-column prop="KPI" label="KPI名称"></el-table-column>
            <el-table-column prop="KPIWeight" label="KPI权重"></el-table-column>
            <el-table-column prop="IsRepeat" label="周期类型">
                <template slot-scope="scope">
                    <span>{{ scope.row.PeriodType==1?"季度":"月度" }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="Explain" label="指标说明"></el-table-column>
            <el-table-column prop="Contents" width="500" label="考核细则"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="UpdateTemplate(scope.row)" type="text">编辑</el-button>
                <el-button @click="relation(scope.row)" type="text">对应关系查看</el-button>

                <el-popconfirm title="确定删除此条信息吗？" @onConfirm="DeleteTemplate(scope.row)">
                  <el-button type="text" slot="reference" style="color:red;">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row style="text-align:right;">
          <el-col>
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
                ></el-pagination>
            </el-col>
      </el-row>
      <el-dialog width="50%" :title="dialogTitle" :visible.sync="dialogVisible" top="10px">
        <el-form :model="TemplaateModel" ref="taskForm" :rules="taskRules">
          <el-form-item label="KPI类型" :label-width="formLabelWidth" size="small">
                <el-select v-model="TemplaateModel.KPIType" style="float:left;" placeholder="请选择KPI类型">
                    <el-option value="4" label="内部管理指标"></el-option>
                    <el-option value="1" label="业绩指标"></el-option>
                    <el-option value="5" label="客户指标"></el-option>
                    <el-option value="6" label="敬业度"></el-option>
                    <el-option value="7" label="重点项目"></el-option>
                    <el-option value="8" label="团队管理"></el-option>
                </el-select>
          </el-form-item>
          <el-form-item label="KPI名称" :label-width="formLabelWidth" prop="KPI">
            <el-input v-model="TemplaateModel.KPI" autocomplete="off" placeholder="请输入KPI名称"></el-input>
          </el-form-item>
          <el-form-item label="周期类型" :label-width="formLabelWidth" size="small" >
                <el-select v-model="TemplaateModel.PeriodType" style="float:left;" placeholder="请选择周期类型">
                    <el-option label="月度" value="0"></el-option>
                    <el-option label="季度" value="1"></el-option>
                </el-select>
          </el-form-item>
          <el-form-item label="KPI权重" :label-width="formLabelWidth" prop="KPIWeight">
            <el-input v-model="TemplaateModel.KPIWeight" autocomplete="off" placeholder="请输入KPI权重"></el-input>
          </el-form-item>
          <el-form-item label="指标说明" :label-width="formLabelWidth" prop="Explain">
            <el-input
              v-model="TemplaateModel.Explain"
              autocomplete="off"
              placeholder="请输入指标说明"
            ></el-input>
          </el-form-item>
          <el-form-item label="考核细则" :label-width="formLabelWidth" prop="Contents">
            <el-input v-model="TemplaateModel.Contents" autocomplete="off" placeholder="请输入考核细则"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="OperTemplaateModel">保存</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import {
  BigKPITemplate,GetBigKPITemplate,BigKPITemplateSave,DelBigKPITemplate,AddBigKPITemplateRelation
} from "../../until/ZeusApiSDK/Logic/KPISettingLogic";
import {
  GetKnowledgeContentDescry,
  EncryptContent
} from "../../until/ZeusApiSDK/Logic/WikiLogic";
import {
  GetCurrentUserInfo,
  GetNewGuid
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate.js";
    import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";  
export default {
  data() {
    return {
      BigTemplateList: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      childrenOverdrafts: [],
      dialogVisible: false,
      dialogTitle: "添加模板",
      TemplaateModel: {},
      currentUser: {},
      taskRules: {
        //用户验证规则
        KPI: [{ required: true, message: "请输入KPI名称", trigger: "blur" }],
        KPIWeight: [{ required: true, message: "请输入KPI权重", trigger: "blur" }],
        Explain: [{ required: true, message: "请输入指标说明", trigger: "blur" }],
        Contents: [{ required: true, message: "请输入考核细则", trigger: "blur" }]
      },
      formLabelWidth: "120px",
      currentRole:{},//当前登录用户角色
    };
  },
  created() {
    this.getCurrentUser();
    this.GetBigTemplateList();

    //获取当前用户角色
    this.getCurrentRole();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetBigTemplateList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetBigTemplateList();
    },
    // Search: function() {
    //   this.pageIndex = 1;
    //   this.GetBigTemplateList();
    // },
    Refresh:function(){
      this.GetBigTemplateList();
    },
    AddTask: function() {
      this.dialogTitle = "添加模板";
      this.dialogVisible = true;
      this.TemplaateModel = {};
    },
    UpdateTemplate: function(row) {
      this.dialogTitle = "编辑模板";
      this.dialogVisible = true;
      GetBigKPITemplate(row.Id).then(res => {
        if(res.Code==200){
            this.TemplaateModel = res.Data;
            var kpiType=this.TemplaateModel.KPIType;
            this.TemplaateModel.KPIType=this.KPITypeFormatter(kpiType);
            // this.TemplaateModel.KPIType=kpiType==4?'内部管理指标':(kpiType==1?"业绩指标":(kpiType==5?"客户指标":(kpiType==6?"敬业度":(kpiType==7?"重点项目":(kpiType==8?"团队管理":"其他"))));
            this.TemplaateModel.PeriodType=this.TemplaateModel.PeriodType==0?"月度":"季度";
        }else{
            this.TemplaateModel ={};
        }
      });
    },
    //跳转到模板对应关系页
    relation: function(row) {
        // this.$router.push('/SysUser/UserInfo?UserID='+data.sysUser.Id+'&name=入职管理');
        this.$router.push('/KPISetting/PerformanceRelation?kpiId='+row.Id);
    },
    getCurrentUser: function() {
      this.currentUser = GetCurrentUserInfo();
    },
    //获取当前用户角色
    getCurrentRole:function(){
        var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
        this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    DeleteTemplate: function(row) {
      DelBigKPITemplate(this.currentUser.UserCode,row.Id).then(res => {
          if(res.Code==200){
              this.$message({
                message: '删除成功',
                type: "success",
                center: true
              });
          }
          else{
              this.$message({
                message: '删除失败',
                type: "danger",
                center: true
              });
          }
          this.GetBigTemplateList();
      });
    },
    OperTemplaateModel: function() {
      this.$refs["taskForm"].validate(valid => {
        if (valid) {
          if (this.TemplaateModel.Id) {
              //编辑
              this.TemplaateModel.Contents=encodeURIComponent(this.TemplaateModel.Contents);//加密
              this.TemplaateModel.PeriodType=this.TemplaateModel.PeriodType=='季度'?1:(this.TemplaateModel.PeriodType=='月度'?0:this.TemplaateModel.PeriodType);
              this.TemplaateModel.KPIType=this.KPITypeFormatterValue(this.TemplaateModel.KPIType);
              this.TemplaateModel.userCode=this.currentUser.UserCode;
              BigKPITemplateSave(this.TemplaateModel).then(res => {
                  if(res.Code==200){
                      this.$message({
                        message: '编辑成功',
                        type: "success",
                        center: true
                      });
                      this.dialogVisible = false;
                      this.GetBigTemplateList();
                  }
                  else{
                      this.$message({
                        message: '编辑失败',
                        type: "danger",
                        center: true
                      });
                  }
              });
          } 
          else {
            console.log('添加');
              //添加
              this.TemplaateModel.Contents=encodeURIComponent(this.TemplaateModel.Contents);//加密
              this.TemplaateModel.types=0;
              this.TemplaateModel.userCode=this.currentUser.UserCode;
              this.TemplaateModel.PeriodType=this.TemplaateModel.PeriodType=='季度'?1:(this.TemplaateModel.PeriodType=='月度'?0:this.TemplaateModel.PeriodType);
              this.TemplaateModel.KPIType=this.KPITypeFormatterValue(this.TemplaateModel.KPIType);
              BigKPITemplateSave(this.TemplaateModel).then(res => {
                  if(res.Code==200){
                      this.$message({
                        message: '添加成功',
                        type: "success",
                        center: true
                      });
                      this.dialogVisible = false;
                      this.GetBigTemplateList();
                  }
                  else{
                      this.$message({
                        message: '添加失败',
                        type: "danger",
                        center: true
                      });
                  }
              });
          }
        }
      });
    },
    //获取绩效模板列表
    GetBigTemplateList: function() {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      BigKPITemplate(
        0,
        this.pageIndex,
        this.pageSize,
        ''
      ).then(pageRes => {
        if(pageRes.Code=200){
            this.BigTemplateList=pageRes.Data.DataList;
            this.totalCount = pageRes.Data.totalCount;
            this.loading=false;
        }else{
            this.BigTemplateList=[];
            this.totalCount = 0;
            this.loading=false;
        }
      });
    },
    KPITypeFormat(row, column, cellValue, index) {
      return this.KPITypeFormatter(cellValue);
    },
    AddBigKPITemplateRelation:function(type){
        AddBigKPITemplateRelation(type,this.currentUser.UserCode).then(res=>{
            if(res.Code==200){
                this.$message({
                    message: '生成成功',
                    type: "success",
                    center: true
                });
            }
            else{
                this.$message({
                    message: '生成失败',
                    type: "danger",
                    center: true
                });
            }
            this.GetBigTemplateList();
        });
    },
    //根据value获取值
    KPITypeFormatter(value) {
      if (value == 0) {
        return "职能指标";
      } else if (value == 1) {
        return "业绩指标";
      } else if (value == 4) {
        return "内部管理指标";
      } else if (value == 5) {
        return "客户指标";
      } else if (value == 6) {
        return "敬业度";
      } else if (value == 7) {
        return "重点项目";
      } else if (value == 8) {
        return "团队管理";
      } 
      else {
        return "其他";
      }
    },
    //根据值获取value
    KPITypeFormatterValue(value) {
      if (value == "职能指标") {
        return 0;
      } else if (value == "业绩指标") {
        return 1;
      } else if (value == "内部管理指标") {
        return 4;
      } else if (value == "客户指标") {
        return 5;
      } else if (value == "敬业度") {
        return 6;
      } else if (value == "重点项目") {
        return 7;
      } else if (value == "团队管理") {
        return 8;
      } 
      else {
        return value;
      }
    },
  }
};
</script>